const RECEIVE_FLIPPER = "flipperUtils/RECEIVE_FLIPPER";

export const flipperReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_FLIPPER:
      return {
        ...state,
        ...action.payload.flipper,
      };

    default:
      return state;
  }
};

export const receiveFlipper = (flipper) => ({
  type: RECEIVE_FLIPPER,
  payload: {
    flipper,
  },
});
